const QUESTION_INTROS = [
  "Okay, let's answer this question.",
  "Can you answer this question?",
  "This is an interesting one. Can you try answering this?",
  "Here's one for you.",
  "Let's see if you can figure this one out.",
  "Alright, give this a try.",
];

const CORRECT_PHRASES = [
  "Wow, that's right!",
  "That's absolutely right!",
  "Yes, that's correct!",
  "Wow, you got it spot on!",
  "Great job, that's correct!",
  "Nice work, that's exactly right!",
];

const INCORRECT_PHRASES = [
  "I'm not sure if that's the right answer. Maybe we can give a try to the next question.",
  "That's not quite it, but let's move on to the next one.",
  "Good try! Let's see the next question.",
  "Not quite, but don't worry, we'll get the next one.",
  "Close, but not the answer we were looking for. Let's try the next question.",
];

export function withRandomIntro(questionText) {
  const intro = QUESTION_INTROS[Math.floor(Math.random() * QUESTION_INTROS.length)];
  return `${intro} ${questionText}`;
}

export function randomCorrectPhrase() {
  return CORRECT_PHRASES[Math.floor(Math.random() * CORRECT_PHRASES.length)];
}

export function randomIncorrectPhrase() {
  return INCORRECT_PHRASES[Math.floor(Math.random() * INCORRECT_PHRASES.length)];
}
